// extracted by mini-css-extract-plugin
module.exports = {"main":"Records_main__2eaAS","wrap":"Records_wrap__3mJlE","title":"Records_title__zXLKG","item":"Records_item__32eUd","readMore":"Records_readMore__23TuJ"};